let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("a2fIC")).then(() => parcelRequire('dnYd0'));